<template>
  <div>
    <v-toolbar class="elevation-1">
      <h4>{{ title }} by Excel</h4>
      <v-spacer></v-spacer>
      <div
        v-if="processFlowIndex === 0 && nobuttons"
        style="display: flex; margin-right: 10px;"
      >
        <v-btn
          small
          v-if="!isSecondary && permissions.includes('student')"
          class="elevation-0 info"
          @click="category = 'Primary Students'"
          >Primary Students</v-btn
        >
        <v-btn
          small
          v-if="isSecondary && permissions.includes('student')"
          class="elevation-0 info"
          @click="category = 'Secondary Students'"
          >Secondary Students</v-btn
        >
        <v-btn
          v-if="permissions.includes('staff')"
          small
          class="elevation-0 info"
          @click="category = 'Staff'"
          >Staff</v-btn
        >
      </div>
      <div
        v-if="processFlowIndex === 0"
        v-show="false"
        @drop="handleDrop"
        @dragover="handleDragover"
        @dragenter="handleDragover"
        class="drag-drop-container"
      >
        <label
          class="file-input-label"
          for="file-input"
          style="display: flex; align-items: center;"
          >{{ buttonTitle }}</label
        >
        <input
          type="file"
          id="file-input"
          ref="inFiles"
          :accept="format"
          @change="previewFiles"
          multiple
        />
      </div>
    </v-toolbar>
  </div>
</template>
<script>
import XLSX from "xlsx";
export default {
  props: ["title", "processFlowIndex", "nobuttons"],
  data() {
    return {
      bulk: {},
      buttonTitle: "",
      category: "",
      // format: "application/vnd.ms-excel" // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
      format:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    };
  },
  watch: {
    bulk: {
      handler: function(value) {
        this.$emit("bulkChanged", value);
      },
      deep: true
    },
    category: {
      handler: function(value) {
        console.log(value);
        if (this.category == "Staff") {
          this.buttonTitle = "Staff File";
        } else if (this.category == "Primary Students") {
          this.buttonTitle = "Primary Student File";
        } else if (this.category == "Secondary Students") {
          this.buttonTitle = "Secondary Student File";
        }
        this.$emit("categoryChanged", this.category);
        this.$refs.inFiles.click();
      }
    }
  },
  computed: {
    isSecondary: function() {
      let activeuser = localStorage.active_user;
      if (!activeuser) {
        return false;
      }

      activeuser = JSON.parse(activeuser);
      if (!activeuser) {
        return false;
      }

      return activeuser.company_sub_type === 2;
    }
  },
  methods: {
    previewFiles() {
      let files = this.$refs.inFiles.files;
      if (files.length > 0) {
        this.processFiles(files);
      }
    },
    handleReset() {},
    handleDragover: function(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },
    fixdata: function(data) {
      var o = "",
        l = 0,
        w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    get_header_row: function(sheet) {
      var headers = [],
        range = XLSX.utils.decode_range(sheet["!ref"]);
      var C,
        R = range.s.r;
      for (C = range.s.c; C <= range.e.c; ++C) {
        var cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
        var hdr = "UNKNOWN " + C;
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    processFiles: function(files) {
      if (files.length === 0) {
        return;
      }
      let self = this;
      for (let file of files) {
        var reader = new FileReader();
        reader.fileName = file.name;
        reader.index = 1;
        reader.onload = function(e) {
          var results,
            data = e.target.result,
            fixedData = self.fixdata(data),
            workbook = XLSX.read(btoa(fixedData), { type: "base64" }),
            firstSheetName = workbook.SheetNames[0],
            worksheet = workbook.Sheets[firstSheetName];
          results = XLSX.utils.sheet_to_json(worksheet);
          let name = e.target.fileName || String(e.target.index);
          name = name.replace(/ /g, "").replace(/\.[^.]*$/, "");
          name = name.toLowerCase();
          if (name) {
            let info = {
              fileName: file.name,
              data: results,
              headers: self.get_header_row(worksheet),
              category: self.category
            };
            self.$set(self.bulk, name, info);
          }
        };
        reader.readAsArrayBuffer(file);
      }
    },
    handleDrop: function(e) {
      if (!this.category) {
        this.$toast.error(
          "Invalid category selection. Click on button to pick the relevant EXCEL file.",
          "Error",
          {
            position: "topCenter"
          }
        );
        return;
      }

      e.stopPropagation();
      e.preventDefault();
      this.bulk = {};
      this.processFiles(e.dataTransfer.files);
    }
  }
};
</script>

<style scoped>
#file-input {
  display: none;
}

.file-input-label {
  display: inline-block;
  margin-left: 10%;
}

.drag-drop-container {
  height: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
